export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

const RFC_REGEX = /^([A-Z&Ñ]{3,4})(\d{2})(\d{2})(\d{2})([A-Z0-9]{3})$/

const validRfcDateSegment = (year, month, day) => {
  const numericMonth = Number(month)
  const numericDay = Number(day)
  if (numericMonth < 1 || numericMonth > 12 || numericDay < 1 || numericDay > 31) return false

  const yearSuffix = Number(year)
  const candidateYears = [1900 + yearSuffix, 2000 + yearSuffix]

  return candidateYears.some(candidateYear => {
    const parsedDate = new Date(candidateYear, numericMonth - 1, numericDay)
    return parsedDate.getFullYear() === candidateYear
      && parsedDate.getMonth() === numericMonth - 1
      && parsedDate.getDate() === numericDay
  })
}

export const validatorRfc = value => {
  if (value === undefined || value === null || value.length === 0) {
    return false
  }

  const normalized = String(value).toUpperCase().replace(/[^A-Z0-9&Ñ]/g, '')
  const matches = normalized.match(RFC_REGEX)
  if (!matches) return false

  const [, , year, month, day] = matches
  return validRfcDateSegment(year, month, day)
}
